var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card mt-2 mb-2",on:{"click":function($event){return _vm.clickCampaign()}}},[_c('img',{staticClass:"card-img-top",attrs:{"src":_vm.campaign.fullImageUrl}}),_c('div',{staticClass:"card-body"},[_c('strong',[_vm._v(_vm._s(_vm.campaign.name))]),_c('div',[_vm._v(_vm._s(_vm.getPointMessage()))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }